import React from "react";
import ReactSelect from "@ui/ReactSelect";
import { useEquipmentsInput } from "./useEquipmentInput";

interface P {
  projectId: string;
  focusableRef: React.RefObject<{
    focus: () => void;
  }>;
  name: string;
  placeholder: string;
  entry: { equipmentIds: string[] };
  column: string;
  allowEquipmentCreation?: boolean;
  setDirty: (dirty: boolean, column: string) => void;
}

const EquipmentSelect = ({
  projectId,
  name,
  placeholder,
  setDirty,
  entry,
  allowEquipmentCreation = false,
  ...props
}: P) => {
  const equipmentsInput = useEquipmentsInput(projectId, [entry]);

  React.useEffect(() => {
    setDirty(equipmentsInput.dirty, props.column);
  }, [equipmentsInput.dirty, props.column, setDirty]);

  return (
    <ReactSelect
      {...props}
      menuPortalTarget={window.document.body}
      ref={props.focusableRef as React.RefObject<HTMLDivElement>}
      isMulti
      name={name}
      placeholder={placeholder}
      value={equipmentsInput.selectedEquipments}
      options={equipmentsInput.equipmentOptions}
      onChange={equipmentsInput.handleEquipmentChanged}
      onCreate={allowEquipmentCreation ? equipmentsInput.handleEquipmentCreated : undefined}
      onEdit={allowEquipmentCreation ? equipmentsInput.handleEquipmentEdited : undefined}
      onDelete={allowEquipmentCreation ? equipmentsInput.handleEquipmentDeleted : undefined}
    />
  );
};

export default React.memo(EquipmentSelect);
